import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { Children, cloneElement, isValidElement } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Builds the grid template areas for the shadow columns
 * @param columnCount - The number of columns in the grid
 * @returns The grid template areas, in this format:
 * "Badge"
 * "Title"
 * "Subheading"
 * "Pricing"
 * "Term"
 * "CTAs"
 * "Subtext"
 * "Features"
 * "Footer"
 */
const buildGridTemplateAreas = () => {
  const sections = ['Badge', 'Title', 'Subheading', 'Pricing', 'Term', 'CTAs', 'Subtext', 'Features', 'Footer'];
  return sections.map(section => `"${section}"`).join('\n');
};
const HSOCMerchCardColumnsLayoutUI = _ref => {
  let {
      children
    } = _ref,
    gridProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(PPUIGrid, Object.assign({
    position: "relative",
    gridAutoColumns: "1fr",
    gridAutoFlow: "row",
    columnGap: "500",
    inlineSize: "100%",
    marginInline: "auto",
    blockSize: "100%",
    gridTemplateAreas: buildGridTemplateAreas()
  }, gridProps, {
    children: Children.map(children, child => {
      if ( /*#__PURE__*/isValidElement(child)) {
        const newCardStyles = {
          showBorder: true,
          radius: '400',
          backgroundColor: 'fill-surface-default'
        };
        const newProps = Object.assign({}, child.props, {
          cardStyles: Object.assign({}, newCardStyles, child.props.cardStyles)
        });
        return /*#__PURE__*/cloneElement(child, newProps);
      }
      return child;
    })
  }));
};
export default HSOCMerchCardColumnsLayoutUI;